import React from "react"
import Product from "./Product"
import Title from "../Globals/Title"
import { StaticQuery, graphql } from "gatsby"

const getProducts = graphql`
 {
    products: allContentfulCoffeeProduct {
    edges {
      node {
        id
        title
        price
        image {
          fluid  {
            src 
            ...GatsbyContentfulFluid_withWebp
          }
        }
      }
    }
  }
}`;
export default function Products() {
   return (
      <StaticQuery
       query={getProducts}
      render={data => {
        return (
            //  <h1>HEllo worlds</h1>
        <section className="py-5">
            <div className="container">
                <Title title="Services"/>
                <div className="row">
                    {data.products.edges.map(({node:product})=>{
 return <Product key={product.id} product={product}/>
                    })}
                </div>
            </div>
        </section>
       
)
      }}
    />
 
 )
}
